import React from 'react';
interface LogoProps {
  tone?: 'light' | 'dark';
  className?: string;
}
export function Logo({
  tone = 'dark',
  className = ''
}: LogoProps) {
  const text = tone === 'light' ? 'text-white' : 'text-ink-900';
  return <span className={`flex items-center gap-2.5 ${className}`} data-id="element-138" data-mp="3qamgdfda4b9w">
      <span aria-hidden="true" className="block h-7 w-7 shrink-0 rounded-full bg-brand-600 sm:h-8 sm:w-8" data-id="element-139" data-mp="3v8eews8fivn2" />
      <span className={`whitespace-nowrap text-[17px] font-semibold tracking-[-0.01em] sm:text-[19px] ${text}`} data-id="element-140" data-mp="mtw4wkyxh60t">
        Elyon Markets
      </span>
    </span>;
}